import { default as hour } from './hour/routes'
import { default as domainScheduleByDate } from './schedule-by-date/routes'
import { default as domainSchedule } from './schedule/routes'
import { default as domainHourGroup } from './group/routes'

export default [
    ...hour,
    ...domainScheduleByDate,
    ...domainSchedule,
    ...domainHourGroup
]
